import React, { useEffect, useRef, useState } from "react";
import { api, formatErr } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";

function messageId() {
  return window.crypto?.randomUUID?.() || "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
    const n = Math.floor(Math.random() * 16); return (c === "x" ? n : (n & 3) | 8).toString(16);
  });
}

export default function GuestTextMessage({ guestId, disabled, onBusyChange, onSent }) {
  const [text, setText] = useState("");
  const [sending, setSending] = useState(false);
  const [error, setError] = useState("");
  const inFlight = useRef(false);
  const attempted = useRef(null);
  const id = useRef(messageId());
  useEffect(() => () => onBusyChange(false), [onBusyChange]);
  const send = async () => {
    if (inFlight.current || disabled || !guestId || !text.trim()) return;
    inFlight.current = true; setSending(true); setError(""); onBusyChange(true);
    attempted.current = attempted.current ?? text.trim();
    try {
      const { data } = await api.post("/public/guest-messages", { guest_id: guestId, request_id: id.current, text: attempted.current });
      onBusyChange(false); onSent("Guest message", data);
    } catch (err) {
      setError(formatErr(err.response?.data?.detail) || "Delivery could not be confirmed. Retry sends the same message without duplicates.");
    } finally {
      inFlight.current = false; setSending(false); onBusyChange(false);
    }
  };
  return <section className="border-t border-border pt-4 space-y-3" data-testid="guest-text-message">
    <label htmlFor="guest-message-text" className="text-sm font-medium">Text message</label>
    <Textarea id="guest-message-text" value={text} onChange={(event) => setText(event.target.value)} maxLength={4000}
      placeholder={guestId ? "Write a message to the crew…" : "Select your name above first"} rows={3}
      disabled={disabled || sending || !guestId || attempted.current !== null} data-testid="guest-text-input" />
    <p className="text-xs text-muted-foreground">Sent as written. No recording or translation required.</p>
    <Button className="rounded-full w-full" disabled={disabled || sending || !guestId || !text.trim()} onClick={send} data-testid="guest-text-send">{sending ? "Sending…" : error ? "Retry same message" : "Send text to crew"}</Button>
    {error && <p role="alert" className="text-sm text-destructive">{error}</p>}
  </section>;
}
